import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FeedService} from '../../feed.service';
import {Subscription} from 'rxjs';

@Component({
  selector: '[app-feed-card]',
  templateUrl: './feed-card.component.html',
  styleUrls: ['./feed-card.component.scss']
})
export class FeedCardComponent implements OnInit, OnDestroy {

  newsItem: any;
  sub: Subscription;
  @Input() name: string;
  @Input() background: string;

  constructor(private feedService: FeedService) {
  }

  ngOnInit() {
    this.sub = this.feedService.load(this.name).subscribe(value => {
      console.log('FeedCardComponent', value);
      this.newsItem = value;
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}
